const REWARDS = [
    {
        img : '',
        title : 'Exclusive Offers',
        lDesc : 'Unlock access to special discounts and promotions reserved just for members. Whether it\'s buy-one-get-one deals, limited-time offers, or seasonal discounts, our members always get first dibs on the best deals. Join now to start saving on your favorite drinks!',
        sDesc : 'Unlock access to special discounts and promotions reserved just for members.',
        link : '#',
        key : 1,
        offers1: [
            {
                title : 'Early Access',
                desc : 'Be first in line for exclusive discounts and limited-time offers.',
                key : 1
            },
            {
                title : 'Savings Galore',
                desc : 'Enjoy member-only deals on your favorite drinks.',
                key : 2
            },
            {
                title : 'Personalized Perks',
                desc : 'Get tailored discounts based on your preferences.',
                key : 3
            }
        ]
    },
    {
        img : '',
        title : 'Rewards Program',
        lDesc : 'Earn points with every purchase and enjoy perks like free drinks and birthday treats. Our rewards program is our way of saying thank you for your loyalty. Every sip gets you closer to freebies, exclusive rewards, and surprises along the way. Sign up today and start earning rewards with every order!', 
        sDesc : 'Earn points with every purchase and enjoy perks like free drinks and birthday treats.',
        link : '#',
        key : 2,
        offers2: [
            {
                title : 'Earn Points, Get Perks',
                desc : 'Collect points with every purchase for free drinks and birthday treats.',
                key : 1
            },
            {
                title : 'Birthday Cheers',
                desc : 'Enjoy a complimentary drink on your special day.',
                key : 2
            },
            {
                title : 'Exclusive Surprises',
                desc : 'Unlock rewards and surprises with every order. Join now!',
                key : 3
            }
        ]

    },
    {
        img : '',
        title : 'Faster Checkout',
        lDesc : 'Streamline your ordering process and enjoy quicker transactions by signing up for an account. No more fumbling for cash or re-entering your payment information every time you order. With a registered account, checkout is a breeze, allowing you to get your hands on your favorite drinks faster than ever before. Join now to experience the convenience of hassle-free ordering!',
        sDesc : 'Streamline your ordering process and enjoy quicker transactions by signing up for an account.',
        link : '#',
        key : 3,
        offers3: [
            {
                title : 'Quick Ordering',
                desc : 'Sign up for an account for speedy transactions.',
                key : 1
            },
            {
                title : 'No More Hassle',
                desc : 'Say goodbye to cash fumbling and payment re-entry.',
                key : 2
            },
            {
                title : 'Free Shipping',
                desc : 'Enjoy complimentary shipping on your orders! Join now for hassle-free ordering!',
                key : 3
            }
        ]
    }
]
export default REWARDS;